import React, { useContext, useState } from "react";
import InputSelect from "../../../../../shared/components/inputs/InputSelect/InputSelect";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useLoading } from "../../../../../shared/context/LoadingContext";
import { ClinicaContext } from "../../../../../shared/context/clinica-context";
import toast from "react-hot-toast";

const LABELS_MODELOS = {
  modelo1: "Modelo 1 (Padrão)",
  modelo2: "Modelo 2",
};

const MODELOS_POR_TIPO = {
  orcamento: ["modelo1"],
  prescricao: ["modelo1", "modelo2"],
  atestado: ["modelo1", "modelo2"],
  impresso: ["modelo1"],
};

function ModalConfiguracoesModelosDocumentos({
  openModal,
  handleModalClose,
  modalData,
  handleUpdate,
  clinicaId,
  sendRequest,
  auth,
}) {
  const { setConfiguracoes } = useContext(ClinicaContext);
  const { startLoading, stopLoading } = useLoading();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [dados, setDados] = useState({
    orcamento: modalData?.orcamento || "modelo1",
    prescricao: modalData?.prescricao || "modelo1",
    atestado: modalData?.atestado || "modelo1",
    impresso: modalData?.impresso || "modelo1",
  });

  const submitHandler = async () => {
    try {
      setIsSubmitting(true);
      startLoading();

      const formData = new FormData();
      formData.append("utilizador", auth.userId);
      formData.append("modelos", JSON.stringify(dados));

      const resposta = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/configuracoes/modelodocumento/${clinicaId}`,
        "PATCH",
        formData,
        { Authorization: "Bearer " + auth.token },
      );

      toast.success("Modelos de documentos atualizados com sucesso!");
      handleUpdate(resposta.configuracao);
      setConfiguracoes(resposta.configuracao);
    } catch (err) {
    } finally {
      stopLoading();
      setIsSubmitting(false);
      handleModalClose();
    }
  };

  return (
    <Modal
      open={openModal}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="fluxo-atendimento__modal__box adicionar-categoria__modal"
        id="modal__adicionar-categoria"
      >
        <h1 className="fluxo-atendimento__modal__titulo">
          Modelos de Documentos
        </h1>
        <div
          className="adicionar-categoria__modal__container"
          style={{
            marginTop: "25px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <InputSelect
            label="Modelo de Orçamento"
            initialValue={LABELS_MODELOS[dados.orcamento]}
            handleChange={(val) =>
              setDados((d) => ({
                ...d,
                orcamento:
                  MODELOS_POR_TIPO.orcamento.find(
                    (k) => LABELS_MODELOS[k] === val,
                  ) || "modelo1",
              }))
            }
            items={MODELOS_POR_TIPO.orcamento.map((m) => LABELS_MODELOS[m])}
          />
          <InputSelect
            label="Modelo de Prescrição"
            initialValue={LABELS_MODELOS[dados.prescricao]}
            handleChange={(val) =>
              setDados((d) => ({
                ...d,
                prescricao:
                  MODELOS_POR_TIPO.prescricao.find(
                    (k) => LABELS_MODELOS[k] === val,
                  ) || "modelo1",
              }))
            }
            items={MODELOS_POR_TIPO.prescricao.map((m) => LABELS_MODELOS[m])}
          />
          <InputSelect
            label="Modelo de Atestado"
            initialValue={LABELS_MODELOS[dados.atestado]}
            handleChange={(val) =>
              setDados((d) => ({
                ...d,
                atestado:
                  MODELOS_POR_TIPO.atestado.find(
                    (k) => LABELS_MODELOS[k] === val,
                  ) || "modelo1",
              }))
            }
            items={MODELOS_POR_TIPO.atestado.map((m) => LABELS_MODELOS[m])}
          />
          <InputSelect
            label="Modelo de Impresso"
            initialValue={LABELS_MODELOS[dados.impresso]}
            handleChange={(val) =>
              setDados((d) => ({
                ...d,
                impresso:
                  MODELOS_POR_TIPO.impresso.find(
                    (k) => LABELS_MODELOS[k] === val,
                  ) || "modelo1",
              }))
            }
            items={MODELOS_POR_TIPO.impresso.map((m) => LABELS_MODELOS[m])}
          />
        </div>

        <div className="fluxo-atendimento__modal__bottom_btns">
          <span
            className="cancel-btn"
            onClick={handleModalClose}
            style={{ display: "block" }}
          >
            Fechar
          </span>
          <span
            disabled={isSubmitting}
            className="blue-button"
            onClick={submitHandler}
          >
            {isSubmitting ? "Guardando" : "Guardar"}
          </span>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalConfiguracoesModelosDocumentos;
